import FetchError from "./fetch.js";

export default class AbortError extends FetchError {
    name = "AbortError";

    constructor(message, result) {
        super(message, result);
    }
}
